"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lastOrDefault = exports.last = void 0;
function last(src, predicate) {
    const last = lastOrDefault(src, predicate);
    if (last === null) {
        throw new Error('Sequence contains no elements');
    }
    return last;
}
exports.last = last;
function lastOrDefault(src, predicate) {
    const arr = [...src];
    if (predicate) {
        for (let i = arr.length - 1; i >= 0; i--) {
            if (predicate(arr[i], i)) {
                return arr[i];
            }
        }
    }
    else {
        if (arr.length > 0) {
            return arr[arr.length - 1];
        }
    }
    return null;
}
exports.lastOrDefault = lastOrDefault;
//# sourceMappingURL=last.js.map